import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  proformaGetById
} from "../../Redux/proformaReduce";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
function DetailsLivraisonProforma() {
  const dispatch = useDispatch();
  const location = useParams();
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [livraison, setLivraison] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailLivraison */
  const detailLivraison = useCallback(async (id) => {
    var det = await dispatch(proformaGetById(id));
    var dataD = await det.payload;
    setData(dataD)
    setLoader(false)
  }, [dispatch]);




  useEffect(() => {
    detailLivraison(id)
  }, [id]);



  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">Détails {data.num_commande}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>Code {t("Wholesaler")}</th>
                              <th>{t("Wholesaler")}</th>
                              <th>{t("No_commande")}</th>
                              <th>{t("date_liv")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr key={"ligne-" + data.id}>
                              <td>{data.proformas?.Code_client}</td>
                              <td>{data.proformas?.Raison_sociale}</td>
                              <td>{data.num_commande}</td>
                              <td>{data.proformas?.date_enlevement}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {data.file && <iframe
                        src={`${Configuration.BACK_BASEURL}proforma/${data.file}`}
                        width="100%"
                        height="600px"
                        style={{ border: "none", marginBottom: "20px" }}
                        title={`PDF Viewer proforma`}
                      ></iframe>   }
                     {data.proformas?.reste &&     
                      <iframe
                        src={`${Configuration.BACK_BASEURL}proforma/${data.proformas?.reste}`}
                        width="100%"
                        height="600px"
                        style={{ border: "none", marginBottom: "20px" }}
                        title={`PDF Viewer reste`}
                      ></iframe>}
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsLivraisonProforma;
